import { EnvironmentUrls } from '../types'

const requiredUrls: (keyof EnvironmentUrls)[] = [
  'msLogin',
  'msAuth',
  'msPlatform',
  'objectclass',
  'signed-upload-url'
]

export default function validateConfigUrls(configUrls: EnvironmentUrls) {
  requiredUrls.forEach((requiredUrl) => {
    if (!configUrls[requiredUrl]) {
      globalThis.alert('Variaveis de ambiente não configuradas')
      console.log('Url: ' + requiredUrl + ' não configurada')
    }
  })

  if (globalThis.waEnv === 'dev') {
    Object.keys(configUrls).forEach((environmentUrl) => {
      if (!requiredUrls.includes(environmentUrl as keyof EnvironmentUrls)) {
        globalThis.alert('Variaveis de ambiente não configuradas')
        console.log('Url: ' + environmentUrl + ' não configurada')
      }
    })
  }
}
